<script>
  // quick links to different lists
  import { listId, followingArray } from './stores.js';
  import { link } from "svelte-routing";

  const quickArray =[
    // {title: "Following", listId: "following"}, //special code in List.svelte
    
    
    
    // {title: "", listId: ""},
    {title: "Atlantic", listId: "house--atlantic"},
    {title: "Axios", listId: "house--axios"},
    {title: "*Brew", listId: "house--brew"},
    {title: "NPR", listId: "house--npr"},
    {title: "Politico", listId: "house--politico"},
    {title: "AM News", listId: "amnews"},
    {title: "Climate", listId: "climate"},
    {title: "Books", listId: "books"},
    {title: "Covid", listId: "virus"},
    {title: "Covid News", listId: "virusnews"},
    {title: "*Covid More", listId: "virusstate"},
    {title: "Gerrymander", listId: "gerrymandering"},
    {title: "Journalists", listId: "newsjournalists"},
    {title: "Media", listId: "media"},
    {title: "Photos", listId: "photos"},
    {title: "*PM News", listId: "pmnews"},
    {title: "Poetry", listId: "poetry"},
    {title: "Reading", listId: "reading"},
    {title: "*Tech", listId: "techindustry"},
    {title: "US Politics", listId: "uspolitics"},
    
    // Axios Newsletters (axios): axiosam,axiosmedia,generate,axioslogin,axiospm,axiosvitals,login
    // NOTE: word before -- is "house" or "recommend" "list" is default
    // see List Component

    // {title: "Climate", listId: "climate"},
    // {title: "Media", listId: "media"},
    // {title: "Voting Rights", listId: "gerrymandering"},
    
  ]
  const clickList = function(title, id){
    //alert('got list: '+title+' ('+id+')');
    // listId.set(id);
    // console.log("@SubNav.svelte 1 listId="+$listId)
    // if (id == "following"){
    //   // console.log("listId should be followingArray: "+$followingArray)
    //   listId.set($followingArray)
    // }
  }
  // console.log("@SubNav.svelte 2 listId="+$listId)
</script>
<div class="subnav">
  <!-- <span class="title">Lists:</span> -->
    <span><a class="listnav" href="/" >Following</a></span>
    <span>&nbsp;</span>
    {#each quickArray as item}
      <!-- <span class="nav" on:click="{() => clickList(item.title, item.listId)}">{item.title}</span> -->
      <span on:click="{() => clickList(item.title, item.listId)}">
        <a class="listnav" use:link href="/list/{item.listId}" >{item.title}</a>
      </span>
    {/each}

</div>

<style>
  .nav:hover {text-decoration: underline;}
  .listnav:active {font-weight: bold; color: red;}
  span {text-align: left; color: black; padding: 0.25rem; width: 7rem;}
  .subnav {display: flex; flex-wrap: wrap; justify-content: flex-start;
  color: cornflowerblue; border-bottom: solid; border-width: 3px; 
  background-color: cornsilk; padding: 0.25rem; font-size: 1.25rem; }
</style>


